/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_Prereq_HelpInputs */

const en_directory_mcp_prereq_help = /** @type {(inputs: Directory_Mcp_Prereq_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP access needs a project token — there is no anonymous access.`)
};

const zh_directory_mcp_prereq_help = /** @type {(inputs: Directory_Mcp_Prereq_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP 访问需要项目令牌——不提供匿名访问。`)
};

/**
* | output |
* | --- |
* | "MCP access needs a project token — there is no anonymous access." |
*
* @param {Directory_Mcp_Prereq_HelpInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_prereq_help = /** @type {((inputs?: Directory_Mcp_Prereq_HelpInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_Prereq_HelpInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_prereq_help(inputs)
	return zh_directory_mcp_prereq_help(inputs)
});
export { directory_mcp_prereq_help as "directory.mcp.prereq_help" }